import React, { FC } from "react";
import { RoomsColors } from "../../utils/constants/RoomsColors";
import "../../styles/components/calendar/allRoomsLegend.scss";
import { Cross } from "../../components";

interface IAllRoomsLegend {
  onClose: () => void;
}

interface RoomChipProps {
  backgroundColor: string;
  name: string;
}

const RoomChip: FC<RoomChipProps> = ({ backgroundColor, name }) => {
  return (
    <div className="room-chip" style={{ backgroundColor }}>
      {name}
    </div>
  );
};

export const AllRoomsLegend: FC<IAllRoomsLegend> = ({ onClose }) => {
  return (
    <div className="legend">
      <RoomChip backgroundColor={RoomsColors.STROUSTRUP} name="Страуструп" />
      <RoomChip backgroundColor={RoomsColors.IKE} name="Айк" />
      <RoomChip backgroundColor={RoomsColors.GOSLING} name="Гослинг" />
      <RoomChip backgroundColor={RoomsColors.ROSSUM} name="Россум" />
      <RoomChip backgroundColor={RoomsColors.GYM} name="Спортзал" />
      <Cross onClick={onClose} />
    </div>
  );
};
